













































































































































































































































































import { ProjectTableUtils, TimeBasedPerformance } from "@/models/project";
import { ProjectService } from "@/services/project-service";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "TrackingProjectsComp",
  components: {},
})
export default class TrackingProjectsComp extends Vue {
  options = [
    { text: "Nothing", value: "" },
    { text: "Year", value: "Y" },
    { text: "Month", value: "M" },
    { text: "Week", value: "W" },
    { text: "Day", value: "D" },
  ];
  isBusy = false;
  max = new Date();
  min = new Date(2005, 0);
  start = moment().startOf("week").toDate();
  end = new Date(); //default today
  selected = "";
  selectedDateOptions = new Array<string>();
  virtualFields = new Array<unknown>();
  calculatedFields = new Array<unknown>();
  project_service: ProjectService = new ProjectService();
  dateOptions = new Array<string>();
  valuesMap = new Map<string, Map<ProjectTableUtils, TimeBasedPerformance>>();
  valuesTables = new Array<ProjectTableUtils | undefined>();
  filter = ["", "", ""];

  totalCumulativeWPS = 0;
  totalCumulativeCost = 0;
  totalCumulativeMol = 0;
  mapTotalValues = new Map<string, number>();
  bUnitOptions = [{ text: "Select an option", value: "" }];
  typeOptions = [{ text: "Select an option", value: "" }];

  mounted() {
    this.selected = "D";
    this.search(true);
    this.getBUnitOptions();
    this.getTypeOptions();
  }

  getBUnitOptions() {
    this.project_service
      .getProjectsBUnit()
      .then((response) => {
        if (response) {
          response.forEach((s) => {
            this.bUnitOptions.push({ text: s, value: s });
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getTypeOptions() {
    this.project_service
      .getTypeOptions()
      .then((response) => {
        if (response) {
          response.forEach((s) => {
            this.typeOptions.push({ text: s, value: s });
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  attributesArray = [
    { key: "produced_value", label: "WPS" },
    //{ key: "cumulative_produced_value", label: "Cumulative WPS" },
    { key: "cost_normalized", label: "Costs" },
    //{ key: "cumulative_cost_normalized", label: "Cumulative costs" },
    {
      key: "mol",
      label: "MOL",
    },
    /*{
      key: "cumulative_mol",
      label: "Cumulative MOL",
    },
    {
      key: "hours",
      label: "Spent hours (and cumulative)",
    },
    {
      key: "percent",
      label: "Percent done (and cumulative)",
    },*/
  ];

  selectAll(): void {
    this.selectedDateOptions.splice(0, this.selectedDateOptions.length);
    this.dateOptions.forEach((element) => {
      this.selectedDateOptions.push(element);
    });
    this.addTable(this.selectedDateOptions);
  }

  deselectAll(): void {
    this.selectedDateOptions.splice(0, this.selectedDateOptions.length);
    this.addTable(this.selectedDateOptions);
  }

  search(selectAll?: boolean): void {
    this.isBusy = true;
    this.valuesTables.splice(0, this.valuesTables.length);
    if (this.start && this.end) {
      const sdate = new Date(this.start);
      const edate = new Date(this.end);
      this.dateOptions.splice(0, this.dateOptions.length);
      this.selectedDateOptions.splice(0, this.selectedDateOptions.length);
      this.project_service
        .getProjectPerformances(
          sdate,
          edate,
          this.selected,
          this.filter[0],
          this.filter[1],
          this.filter[2]
        )
        .then((response) => {
          if (response) {
            this.mapTotalValues = new Map<string, number>();
            this.totalCumulativeWPS = 0;
            this.totalCumulativeCost = 0;
            this.totalCumulativeMol = 0;
            this.dateOptions.splice(0, this.dateOptions.length);
            this.valuesMap = new Map<
              string,
              Map<ProjectTableUtils, TimeBasedPerformance>
            >();
            response.forEach((v) => {
              const p = new ProjectTableUtils();
              p.name = v.name;
              p.business_unit = v.business_unit;
              p.project_type = v.project_type;
              p.start_cumulative_spent_hours = v.start_cumulative_spent_hours;
              p.start_cumulative_spent_hours_normalized =
                v.start_cumulative_spent_hours_normalized;
              p.start_cumulative_cost_normalized =
                v.start_cumulative_cost_normalized;
              p.start_cumulative_produced_value =
                v.start_cumulative_produced_value;
              p.start_cumulative_done_percent = v.start_cumulative_done_percent;

              p.end_cumulative_spent_hours = v.end_cumulative_spent_hours;
              p.end_cumulative_spent_hours_normalized =
                v.end_cumulative_spent_hours_normalized;
              p.end_cumulative_cost_normalized =
                v.end_cumulative_cost_normalized;
              p.end_cumulative_produced_value = v.end_cumulative_produced_value;
              p.end_cumulative_done_percent = v.end_cumulative_done_percent;
              this.valuesTables.push(p);
              this.totalCumulativeWPS =
                this.totalCumulativeWPS +
                (p.end_cumulative_produced_value -
                  p.start_cumulative_produced_value);
              this.totalCumulativeCost =
                this.totalCumulativeWPS +
                (p.end_cumulative_cost_normalized -
                  p.start_cumulative_cost_normalized);
              this.totalCumulativeMol =
                this.totalCumulativeMol +
                (p.end_cumulative_produced_value -
                  p.end_cumulative_cost_normalized) -
                (p.start_cumulative_produced_value -
                  p.start_cumulative_cost_normalized);
              v.time_slots.forEach((ts) => {
                let innerMap = this.valuesMap.get(ts.time_slot);
                if (!innerMap) {
                  innerMap = new Map<ProjectTableUtils, TimeBasedPerformance>();
                }
                innerMap.set(p, ts.total_performance);

                const produced_value = this.mapTotalValues.has(
                  ts.time_slot + "/" + "produced_value"
                )
                  ? this.mapTotalValues.get(
                      ts.time_slot + "/" + "produced_value"
                    )
                  : 0;
                const cost_normalized = this.mapTotalValues.has(
                  ts.time_slot + "/" + "cost_normalized"
                )
                  ? this.mapTotalValues.get(
                      ts.time_slot + "/" + "cost_normalized"
                    )
                  : 0;
                const mol = this.mapTotalValues.has(ts.time_slot + "/" + "mol")
                  ? this.mapTotalValues.get(ts.time_slot + "/" + "mol")
                  : 0;

                this.mapTotalValues.set(
                  ts.time_slot + "/" + "produced_value",
                  (produced_value === undefined ? 0 : produced_value) +
                    ts.total_performance.produced_value
                );
                this.mapTotalValues.set(
                  ts.time_slot + "/" + "cost_normalized",
                  (cost_normalized === undefined ? 0 : cost_normalized) +
                    ts.total_performance.cost_normalized
                );
                this.mapTotalValues.set(
                  ts.time_slot + "/" + "mol",
                  (mol === undefined ? 0 : mol) +
                    ts.total_performance.produced_value -
                    ts.total_performance.cost_normalized
                );

                this.valuesMap.set(ts.time_slot, innerMap);
              });
            });
            for (const key of this.valuesMap.keys()) {
              this.dateOptions.push(key);
            }
            if (this.dateOptions.length == 1) {
              this.selectAll();
            }
            if (selectAll === true) {
              this.selectAll();
            }
            this.isBusy = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.isBusy = false;
        });
    }
  }

  addTable(checked: string[]) {
    const map = new Map<ProjectTableUtils, Map<string, TimeBasedPerformance>>();
    checked.forEach((c) => {
      const innerMap = this.valuesMap.get(c);
      if (innerMap !== undefined) {
        for (const ptu of innerMap.keys()) {
          let map2 = map.get(ptu);
          if (!map2) {
            map2 = new Map<string, TimeBasedPerformance>();
          }
          const tbp = innerMap.get(ptu);
          if (tbp !== undefined) {
            map2.set(c, tbp);
          }
          map.set(ptu, map2);
        }
      }
      /*this.valuesMap.get(c)?.active_projects.forEach((element) => {
          let innerMap = map.get(element.name);
          if (!innerMap) {
            innerMap = new Map<string, TimeBasedPerformance>();
          }
          innerMap.set(c, element.total_performance);
          map.set(element.name, innerMap);
        });*/
    });
    for (const ptu of map.keys()) {
      const mappa = map.get(ptu);
      ptu.slotValues =
        mappa !== undefined ? mappa : new Map<string, TimeBasedPerformance>();
    }
  }

  get fields() {
    let array = new Array<unknown>();
    array.push(
      {
        key: "name",
        stickyColumn: true,
        variant: "primary",
        class: "font-weight-bold",
        sortable: true,
      },
      {
        key: "business_unit",
        label: "Business Unit",
        variant: "primary",
        sortable: true,
      },
      {
        key: "project_type",
        label: "Project Type",
        variant: "primary",
        sortable: true,
      }
    );
    //array.push({ key: "cumulative_hours", label: "Cumulative Hours" });
    array.push({
      key: "cumulative_wps",
      sortable: true,
      tdClass: (value: string, key: string, item: ProjectTableUtils) => {
        return this.getTdClass(key, item);
      },
    });
    array.push({ key: "cumulative_cost", sortable: true });
    array.push({
      key: "cumulative_mol",
      sortable: true,
      tdClass: (value: string, key: string, item: ProjectTableUtils) => {
        return this.getTdClass(key, item);
      },
    });
    array.push({
      key: "cumulative_done",
      sortable: true,
      tdClass: (value: string, key: string, item: ProjectTableUtils) => {
        return this.getTdClass(key, item);
      },
    });
    this.virtualFields = new Array<unknown>();
    this.calculatedFields = new Array<unknown>();
    this.selectedDateOptions.forEach((sdo) => {
      this.attributesArray.forEach((element) => {
        this.virtualFields.push({
          key: sdo + "/" + element.key,
          label: element.label,
          slot: sdo,
          attr: element.key,
          sortable: true,
          sortByFormatted: false,
          tdClass: (value: string, key: string, item: ProjectTableUtils) => {
            return this.getTdClass(key, item);
          },
        });
      });
    });
    array = array.concat(this.virtualFields);
    return array;
  }

  getTdClass(key: string, item: ProjectTableUtils) {
    if (key == "cumulative_mol") {
      if (
        item != undefined &&
        item.end_cumulative_produced_value -
          item.end_cumulative_cost_normalized -
          (item.start_cumulative_produced_value -
            item.start_cumulative_cost_normalized) <
          0
      ) {
        return "table-danger";
      }
    }
    if (key == "cumulative_done") {
      if (
        item != undefined &&
        item.end_cumulative_done_percent - item.start_cumulative_done_percent <
          0
      ) {
        return "bg-danger";
      }
    }
    if (key == "cumulative_wps") {
      if (
        item != undefined &&
        item.end_cumulative_produced_value -
          item.start_cumulative_produced_value <
          0
      ) {
        return "bg-danger";
      }
    }
    const slot: string = key.substring(0, key.indexOf("/"));
    const attr: string = key.substring(key.indexOf("/") + 1);
    if (attr == "mol") {
      if (item.slotValues?.get(slot)) {
        const perf: TimeBasedPerformance | undefined =
          item.slotValues?.get(slot);
        if (
          perf != undefined &&
          perf.produced_value - perf.cost_normalized < 0
        ) {
          return "table-danger";
        }
      }
    }
    if (attr == "wps") {
      if (item.slotValues?.get(slot)) {
        const perf: TimeBasedPerformance | undefined =
          item.slotValues?.get(slot);
        if (perf != undefined && perf.produced_value < 0) {
          return "bg-danger";
        }
      }
    }
    return "";
  }

  colorClass(i: number) {
    if (i % 2 == 0) {
      return "bg-secondary";
    }
    return "bg-light";
  }

  getFieldValue(
    map: Map<string, TimeBasedPerformance>,
    field: {
      key: string;
      label: string;
      slot: string;
      attr: string;
      tdClass: string;
    }
  ) {
    const perf: TimeBasedPerformance | undefined = map.get(field.slot);
    if (perf != undefined) {
      switch (field.attr) {
        case "mol":
          return Vue.filter("currency")(
            perf.produced_value - perf.cost_normalized
          );
        /*case "cumulative_mol":
          return Vue.filter("currency")(
            perf.cumulative_produced_value - perf.cumulative_cost_normalized
          );
        case "hours":
          return (
            Vue.filter("localeNumber")(perf.spent_hours_normalized) +
            " h (" +
            Vue.filter("localeNumber")(perf.cumulative_spent_hours_normalized) +
            " h)"
          );
        case "percent":
          return (
            Vue.filter("localeNumber")(perf.done_percent) +
            "%" +
            "(" +
            Vue.filter("localeNumber")(perf.cumulative_done_percent) +
            "%)"
          );
        case "produced_value":
          field.tdClass = "custom-border";
          return Vue.filter("currency")(perf[field.attr]);*/
        default:
          if (
            field.attr == "produced_value" ||
            field.attr == "cost_normalized"
          ) {
            return Vue.filter("currency")(perf[field.attr]);
          } else {
            return "";
          }
      }
    } else {
      return "";
    }
  }

  mySortCompare(a: ProjectTableUtils, b: ProjectTableUtils, key: string) {
    if (key === "cumulative_wps") {
      return (
        a.end_cumulative_produced_value -
        a.start_cumulative_produced_value -
        (b.end_cumulative_produced_value - b.start_cumulative_produced_value)
      );
    } else if (key === "cumulative_cost") {
      return (
        a.end_cumulative_cost_normalized -
        a.start_cumulative_cost_normalized -
        (b.end_cumulative_cost_normalized - b.start_cumulative_cost_normalized)
      );
    } else if (key === "cumulative_mol") {
      return (
        a.end_cumulative_produced_value -
        a.end_cumulative_cost_normalized -
        (a.start_cumulative_produced_value -
          a.start_cumulative_cost_normalized) -
        (b.end_cumulative_produced_value -
          b.end_cumulative_cost_normalized -
          (b.start_cumulative_produced_value -
            b.start_cumulative_cost_normalized))
      );
    } else if (key === "cumulative_done") {
      return (
        a.end_cumulative_done_percent -
        a.start_cumulative_done_percent -
        (b.end_cumulative_done_percent - b.start_cumulative_done_percent)
      );
    } else if (key.includes("/produced_value")) {
      const slotA = a.slotValues.get(key.substring(0, key.indexOf("/")));
      const slotB = b.slotValues.get(key.substring(0, key.indexOf("/")));
      const valA = slotA != undefined ? slotA.produced_value : 0;
      const valB = slotB != undefined ? slotB.produced_value : 0;
      return valA - valB;
    } else if (key.includes("/cost_normalized")) {
      const slotA = a.slotValues.get(key.substring(0, key.indexOf("/")));
      const slotB = b.slotValues.get(key.substring(0, key.indexOf("/")));
      const valA = slotA != undefined ? slotA.cost_normalized : 0;
      const valB = slotB != undefined ? slotB.cost_normalized : 0;
      return valA - valB;
    } else if (key.includes("/mol")) {
      const slotA = a.slotValues.get(key.substring(0, key.indexOf("/")));
      const slotB = b.slotValues.get(key.substring(0, key.indexOf("/")));
      const valA =
        slotA != undefined ? slotA.produced_value - slotA.cost_normalized : 0;
      const valB =
        slotB != undefined ? slotB.produced_value - slotB.cost_normalized : 0;
      return valA - valB;
    } else {
      return false;
    }
  }
}
